import { numberUtils } from "aa-utils";

export const formatNumberFractionDigits = (value, numberUtilsProps) =>
  numberUtils.formatNumber(value, {
    minFractionDigits: 2,
    maxFractionDigits: 2,
    roundingMode: "halfUp",
    ...numberUtilsProps,
  });
